import * as Yup from "yup";
import {t} from "i18next";

export type NewAccreditationForm = {
    annualRevenue: number | null;
    netProfit: number | null;
    bankGuarantee: boolean;
    creditRating: { id: number | null, label: string } | null
    objectCount: number | null;
    averageCostOfProjects: number | null;
    geographyOfProjects: [{ id: number | null, label: string }] | null;
    iso9001: boolean;
    iso14001: boolean
    leed: boolean
    environmentalPolicy: boolean
    useOfEnvironmentallyFriendlyMaterials: boolean
    wasteRecyclingPercentage: number
    workingConditions: { id: number | null, label: string } | null
    availabilityOfControlSystems: boolean
    totalPriceAccordingToEstimate: number | null
    paymentFlexibility: { id: number | null, label: string } | null
    registrationInStateRegisters: boolean
    noLitigation: boolean
    registerOfUnscrupulousSuppliers: boolean
    availabilityOfCompliancePolicy: boolean
    anHonestyAgreementHasBeenSigned: boolean

}

export const initialValues: NewAccreditationForm = {
    annualRevenue: null,
    netProfit: null,
    bankGuarantee: false,
    creditRating: null,
    objectCount: null,
    averageCostOfProjects: null,
    geographyOfProjects: null,
    iso9001: false,
    iso14001: false,
    leed: false,
    environmentalPolicy: false,
    useOfEnvironmentallyFriendlyMaterials: false,
    wasteRecyclingPercentage: 0,
    workingConditions: null,
    availabilityOfControlSystems: false,
    totalPriceAccordingToEstimate: null,
    paymentFlexibility: null,
    registrationInStateRegisters: false,
    noLitigation: false,
    registerOfUnscrupulousSuppliers: false,
    availabilityOfCompliancePolicy: false,
    anHonestyAgreementHasBeenSigned: false
};

export function ValidationSchema() {
    return Yup.object({
        annualRevenue: Yup.number()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        netProfit: Yup.number()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        bankGuarantee: Yup.boolean()
            .typeError(t("validation.required")),
        creditRating: Yup.object({
            value: Yup.string().required(t("validation.required")),
        }),
        objectCount: Yup.number()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        averageCostOfProjects: Yup.number()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        geographyOfProjects: Yup.object({
            value: Yup.string().required(t("validation.required")),
        }),
        iso9001: Yup.boolean()
            .typeError(t("validation.required")),
        iso14001: Yup.boolean()
            .typeError(t("validation.required")),
        leeed: Yup.boolean()
            .typeError(t("validation.required")),
        environmentalPolicy: Yup.boolean()
            .typeError(t("validation.required")),
        useOfEnvironmentallyFriendlyMaterials: Yup.boolean()
            .typeError(t("validation.required")),
        wasteRecyclingPercentage: Yup.number()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        workingConditions: Yup.object({
            value: Yup.string().required(t("validation.required")),
        }),
        totalPriceAccordingToEstimate: Yup.number()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        paymentFlexibility: Yup.object({
            value: Yup.string().required(t("validation.required")),
        }),
        registrationInStateRegisters: Yup.boolean()
            .typeError(t("validation.required")),
        noLitigation: Yup.boolean()
            .typeError(t("validation.required")),
        registerOfUnscrupulousSuppliers: Yup.boolean()
            .typeError(t("validation.required")),
        availabilityOfCompliancePolicy: Yup.boolean()
            .typeError(t("validation.required")),
        anHonestyAgreementHasBeenSigned: Yup.boolean()
            .typeError(t("validation.required")),
    })
}